export default __webpack_public_path__ + "static/media/truck-01-thumbnail.bdf49ead.jpg";